import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import SectionBlock from './SectionBlock';
import { fmtLocalDate as fmtDate } from '../../../utils/dateUtils';

export default function FreeTrialSettingDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  return (
    <Box>
      <SectionBlock title="Campaign Window" />
      <FieldRow
        label="Start Date"
        value={fmtDate(data.startAt)}
        isChanged={diffKeys.has('startAt')}
        side={side}
      />
      <FieldRow
        label="End Date"
        value={fmtDate(data.endAt)}
        isChanged={diffKeys.has('endAt')}
        side={side}
      />
      <FieldRow
        label="Enabled"
        value={data.isEnabled ? 'Yes' : 'No'}
        isChanged={diffKeys.has('isEnabled')}
        side={side}
      />
    </Box>
  );
}
